import React from 'react';
import { useNavigate } from 'react-router-dom';
import team from '../team-data/team';

const UserBioCard = ({ userSlug, clickable = true, styleImage = null }) => {
  const navigate = useNavigate();
  
  const handleNav = clickable ? () => navigate(`/about-us/team/${userSlug}`) : null;

  const user = team[userSlug];

  if (!user) {
    return (
      <div className="card-modern p-4 text-center">
        <i className="bi bi-person-x text-muted fs-1 mb-3"></i>
        <p className="text-muted">User not found</p>
      </div>
    );
  }

  return (
    <div 
      className="user-bio-card h-100 w-100" 
      onClick={handleNav}
      style={{cursor: clickable ? 'pointer' : 'default'}}
    >
      <div className="card-body p-4 h-100 d-flex flex-column align-items-center text-center">
        <div className="position-relative mb-3">
          <img 
            src={user.userImage} 
            alt={user.fullName} 
            className="circle-image" 
            style={{
              ...styleImage,
              width: '160px',
              height: '160px'
            }} 
          />
          {clickable && (
            <div className="position-absolute bottom-0 end-0 bg-primary rounded-circle p-2">
              <i className="bi bi-arrow-right text-white small"></i>
            </div>
          )}
        </div>
        
        <div className="flex-grow-1 d-flex flex-column justify-content-center">
          <h5 className="text1 mb-2" style={{fontSize: '1.25rem', color: 'var(--gray-800)'}}>
            {user.fullName}
          </h5>
          <p className="text2 text-primary fw-semibold mb-0" style={{fontSize: '0.95rem'}}>
            {user.title}
          </p>
        </div>
        
        {clickable && (
          <div className="mt-3">
            <small className="text-muted d-flex align-items-center justify-content-center">
              <span className="me-1">View Profile</span>
              <i className="bi bi-chevron-right small"></i>
            </small>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserBioCard;
